/* Aromante · Carrito lateral y regalos
   - Arriba: Regresar + logo. Journey en 3 tramos iguales (2, 3 y 4 perfumes).
   - Productos, regalos (muy visibles), sugerencias en renglones, protección de envío, total y pago.
   - Regalos uno por uno: primero el jabón (toca izquierda o derecha), luego los perfumes de 30 ml
     (carrusel horizontal infinito con filtros y buscador). Tocar = agregar, sin botón de confirmar.
   - El selector vuelve a aparecer cada vez que el carrito cambia y falta algún regalo.
   - Regla: paquetes de 4 (1 jabón + 2 minis) y lo que sobra: 3 -> 1 jabón + 1 mini, 2 -> 1 jabón.
   - Los precios los pone la app (función de descuento). Aquí no se calcula ningún descuento.
   - Reemplaza a UpCart: define window.upcartOpenCart / upcartRefreshCart para el resto del tema. */
(function () {
  if (customElements.get('aro-cart')) return;

  const GIFT_KEY = '_aro_regalo';
  const CLONE_CACHE = 'aroCloneMap';

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const sized = (url, w) => (url ? String(url).replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : '');

  /* Íconos (los mismos trazos del armador de paquetes) */
  const svg = (w, d) => '<svg width="' + w + '" height="' + w + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  const IC = {
    soap: (w) => svg(w, '<rect x="3.5" y="9" width="17" height="10" rx="3"/><path d="M8 9V7.5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2V9"/><circle cx="17.5" cy="4" r="1"/><circle cx="20" cy="6.5" r=".7"/>'),
    mini: (w) => svg(w, '<rect x="6.5" y="9" width="11" height="12" rx="2"/><path d="M10 9V6.5h4V9M9.5 3.5h5v3h-5z"/><path d="M9.5 14h5"/>'),
    truck: (w) => svg(w, '<path d="M3 6.5h11v9H3zM14 9.5h3.6l3 3v3H14"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/>'),
    tag: (w) => svg(w, '<path d="M3.5 12.5l8-8h8v8l-8 8z"/><circle cx="15.5" cy="8.5" r="1.4"/>'),
    gift: (w) => svg(w, '<rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M12 9v11M3.5 13h17M12 9c-1.5-3-5-3.5-5-1.5S10 9 12 9zm0 0c1.5-3 5-3.5 5-1.5S14 9 12 9z"/>'),
    spark: (w) => svg(w, '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M19 16l.7 1.8 1.8.7-1.8.7L19 21l-.7-1.8-1.8-.7 1.8-.7z"/>'),
    crown: (w) => svg(w, '<path d="M3.5 8l4.2 3.6L12 5l4.3 6.6L20.5 8l-1.8 10H5.3z"/><path d="M5.5 21h13"/>'),
    trash: (w) => svg(w, '<path d="M4 7h16M10 11v6M14 11v6M5.5 7l1 12.5a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5l1-12.5M9 7V4.5h6V7"/>'),
    plus: (w) => svg(w, '<path d="M12 5v14M5 12h14"/>'),
  };

  /* Íconos de familias olfativas */
  const FAM_IC = {
    citricos: '<circle cx="12" cy="12" r="8"/><path d="M12 4v16M5.1 8l13.8 8M5.1 16l13.8-8"/>',
    fougere: '<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14z"/><path d="M5 19l8-8M9 15h4M11 13V9"/>',
    amaderados: '<path d="M12 3l5 7h-3l4 6H6l4-6H7z"/><path d="M12 16v5"/>',
    orientales: '<path d="M15 4a8 8 0 1 0 5 13A7 7 0 0 1 15 4z"/>',
    especiados: '<path d="M12 3l2 6 6-2-4 5 4 5-6-2-2 6-2-6-6 2 4-5-4-5 6 2z"/>',
    dulces: '<path d="M7 11h10l-1.5 9h-7z"/><path d="M6 11a6 6 0 0 1 12 0"/><path d="M12 3v2"/>',
  };
  const FAM_DEF = { citricos: '#C8D491', fougere: '#44A7C5', amaderados: '#744E4E', orientales: '#D6C22E', especiados: '#DBC2D7', dulces: '#A0375F' };
  const hexRgb = (h) => { const m = String(h || '').replace('#', '').match(/^([0-9a-f]{6})$/i); if (!m) return [91, 107, 133]; const n = parseInt(m[1], 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const lum = (h) => { const [r, g, b] = hexRgb(h); return (0.299 * r + 0.587 * g + 0.114 * b) / 255; };
  /* Color legible para el ícono: los tonos muy claros se oscurecen */
  const ink = (h, k) => { const [r, g, b] = hexRgb(h); const f = k == null ? (lum(h) > .6 ? .45 : lum(h) > .45 ? .75 : 1) : k; return 'rgb(' + [r, g, b].map((v) => Math.round(v * f)).join(',') + ')'; };

  function rule(perfumes) {
    const de4 = Math.floor(perfumes / 4);
    const resto = perfumes % 4;
    return {
      minis: de4 * 2 + (resto === 3 ? 1 : 0),
      soaps: de4 + (resto >= 2 ? 1 : 0),
      pct: perfumes >= 4 ? 15 : perfumes === 3 ? 10 : 0,
    };
  }

  class AroCart extends HTMLElement {
    connectedCallback() {
      try { this.cfg = JSON.parse(this.querySelector('[data-cart-config]').textContent); } catch (e) { console.error('[aro-cart] config', e); return; }
      this.root = this.cfg.root || '/';
      this.byHandle = new Map(this.cfg.perfumes.map((p) => [p.h, p]));
      this.cloneMap = this.loadCloneMap();
      this.cart = null;
      this.busy = false;
      this.giftOpen = false;
      this.snoozed = false;
      this.hidden = true;
      this.$ = (sel) => this.querySelector(sel);
      this.panel = this.$('.aro-cart__panel');
      this.gift = this.$('[data-gift]');
      this.rail = this.$('[data-gift-rail]');

      this.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.querySelectorAll('[data-gift-close]').forEach((b) => b.addEventListener('click', () => this.closeGift(true)));
      const search = this.$('[data-gift-search]');
      if (search) search.addEventListener('input', () => { this.giftQuery = norm(search.value); this.renderRail(); });
      this.querySelectorAll('[data-rail]').forEach((b) => b.addEventListener('click', () => this.nudgeRail(Number(b.dataset.rail))));
      if (this.rail) {
        this.rail.addEventListener('scroll', () => this.loopRail(), { passive: true });
        this.rail.addEventListener('pointerdown', (e) => { this.railX = e.clientX; }, { passive: true });
      }
      const prot = this.$('[data-protection]');
      if (prot) prot.addEventListener('change', () => this.toggleProtection(prot.checked));
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.giftOpen) this.closeGift(true); else this.close();
      });
      this.addEventListener('click', (e) => this.onClick(e));
      this.setupSwipe();

      /* El ícono del carrito del header abre este carrito (no la página /cart ni el cajón de Dawn) */
      document.addEventListener('click', (e) => {
        const a = e.target.closest('#cart-icon-bubble, .header__icon--cart');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open();
      }, true);

      /* Compatibilidad con el resto del tema */
      window.upcartOpenCart = () => this.open();
      window.upcartRefreshCart = () => { this.snoozed = false; return this.refresh(); };
      window.aroCart = this;
      document.addEventListener('aro:cart-added', () => { this.snoozed = false; this.refresh(); });
      /* El catálogo vuelve a pintar las cards al filtrar o paginar */
      document.addEventListener('aro:grid-updated', () => { this.pricesDirty = true; if (this.cart) this.applyPrices(); });

      this.refresh();
    }

    /* ---------- datos ---------- */
    async api(path, body) {
      const opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
      const res = await fetch(this.root + path, opts);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito');
      return data;
    }

    async refresh() {
      try {
        this.cart = await this.api('cart.js');
        await this.reconcile();
        this.render();
        this.maybeOpenGift();
      } catch (e) { console.error('[aro-cart]', e); }
    }

    loadCloneMap() { try { return JSON.parse(sessionStorage.getItem(CLONE_CACHE) || '{}'); } catch (e) { return {}; } }
    saveCloneMap() { try { sessionStorage.setItem(CLONE_CACHE, JSON.stringify(this.cloneMap)); } catch (e) {} }

    /* Copias de BOGOS: busca la variante de regalo de cada perfume (solo en modo pruebas) */
    async resolveClones() {
      if (this.cfg.giftSource !== 'clones') return;
      const todo = this.cfg.perfumes.filter((p) => !(p.h in this.cloneMap));
      if (!todo.length) return;
      await Promise.all(todo.map(async (p) => {
        try {
          const r = await fetch(this.root + 'products/' + p.h + this.cfg.cloneSuffix + '.js', { headers: { Accept: 'application/json' } });
          if (!r.ok) { this.cloneMap[p.h] = null; return; }
          const d = await r.json();
          const v = (d.variants || []).find((x) => /30/.test(x.title)) || (d.variants || [])[0];
          this.cloneMap[p.h] = v ? v.id : null;
        } catch (e) { this.cloneMap[p.h] = null; }
      }));
      this.saveCloneMap();
    }

    /* ---------- clasificación de líneas ---------- */
    isClone(item) { return String(item.handle || '').endsWith(this.cfg.cloneSuffix); }
    baseHandle(item) { return String(item.handle || '').replace(this.cfg.cloneSuffix, ''); }
    isSoap(item) { const h = this.baseHandle(item); return this.cfg.soaps.some((s) => s.handle === h); }
    isProtection(item) { return !!this.cfg.protection && item.variant_id === this.cfg.protection.id; }
    giftType(item) {
      const prop = item.properties && item.properties[GIFT_KEY];
      if (this.isSoap(item)) return (prop || this.isClone(item)) ? 'soap' : null;
      if (/30\s*ml/i.test(item.variant_title || '') || this.isClone(item) || prop === 'mini') return 'mini';
      return null;
    }
    isPerfume(item) {
      if (this.giftType(item) || this.isProtection(item)) return false;
      return /100\s*ml/i.test(item.variant_title || '') && this.byHandle.has(item.handle);
    }

    state() {
      const items = (this.cart && this.cart.items) || [];
      const count = items.filter((i) => this.isPerfume(i)).reduce((s, i) => s + i.quantity, 0);
      const earned = rule(count);
      const minis = items.filter((i) => this.giftType(i) === 'mini');
      const soaps = items.filter((i) => this.giftType(i) === 'soap');
      const nMinis = minis.reduce((s, i) => s + i.quantity, 0);
      const nSoaps = soaps.reduce((s, i) => s + i.quantity, 0);
      return {
        items, count, earned, minis, soaps, nMinis, nSoaps,
        needMinis: Math.max(0, earned.minis - nMinis),
        needSoaps: Math.max(0, earned.soaps - nSoaps),
        extraMinis: Math.max(0, nMinis - earned.minis),
        extraSoaps: Math.max(0, nSoaps - earned.soaps),
      };
    }

    /* Quita regalos de más, empezando por el último que se agregó */
    async reconcile() {
      if (this.busy) return;
      const st = this.state();
      const updates = {};
      const trim = (lines, extra) => {
        for (let i = lines.length - 1; i >= 0 && extra > 0; i--) {
          const n = Math.min(lines[i].quantity, extra);
          updates[lines[i].key] = lines[i].quantity - n;
          extra -= n;
        }
      };
      trim(st.minis, st.extraMinis);
      trim(st.soaps, st.extraSoaps);
      if (!Object.keys(updates).length) return;
      this.busy = true;
      try {
        this.cart = await this.api('cart/update.js', { updates });
        this.toast('Ajustamos tus regalos a tu paquete');
      } finally { this.busy = false; }
    }

    /* El selector aparece solo cuando el carrito está abierto y falta algún regalo */
    maybeOpenGift() {
      if (!this.cfg.promo || this.cfg.autoOpenGifts === false || this.hidden || this.giftOpen || this.snoozed || this.busy) return;
      const st = this.state();
      if (st.needSoaps || st.needMinis) this.openGift();
    }

    /* ---------- abrir / cerrar ---------- */
    open() {
      this.hidden = false;
      this.snoozed = false;
      this.removeAttribute('hidden');
      this.lockScroll();
      document.documentElement.classList.add('aro-cart-open');
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.lastFocus = document.activeElement;
      setTimeout(() => this.panel.focus({ preventScroll: true }), 50);
      this.refresh();
    }

    close() {
      if (this.giftOpen) this.closeGift(false);
      this.classList.remove('is-open');
      this.panel.style.transform = '';
      document.documentElement.classList.remove('aro-cart-open');
      this.unlockScroll();
      setTimeout(() => { this.setAttribute('hidden', ''); this.hidden = true; }, 320);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    /* Mientras el carrito está abierto la página de fondo no se mueve (también en iPhone) */
    lockScroll() {
      if (this.locked) return;
      this.locked = true;
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const b = document.body.style;
      this.bodyPrev = { position: b.position, top: b.top, left: b.left, right: b.right, width: b.width };
      b.position = 'fixed'; b.top = -this.scrollY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    }

    unlockScroll() {
      if (!this.locked) return;
      this.locked = false;
      Object.assign(document.body.style, this.bodyPrev || { position: '', top: '', left: '', right: '', width: '' });
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, this.scrollY || 0);
      html.style.scrollBehavior = prev;
    }

    /* Precios de toda la tienda con el descuento que ya tiene activo el cliente (10% con 3, 15% con 4 o más) */
    applyPrices() {
      const st = this.state();
      const pct = this.cfg.promo ? rule(st.count).pct : 0;
      if (pct === this.pricePct && !this.pricesDirty) return;
      this.pricePct = pct;
      this.pricesDirty = false;
      const iso = this.cfg.currency || 'MXN';
      const fmt = (c) => { const v = (Math.max(0, c) / 100).toFixed(2).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return iso + ' ' + v.join('.'); };
      document.querySelectorAll('[data-aro-price]').forEach((el) => {
        if (el.dataset.aroOrig == null) el.dataset.aroOrig = el.innerHTML;
        if (!pct) { el.innerHTML = el.dataset.aroOrig; el.classList.remove('aro-dp'); return; }
        const p = parseInt(el.dataset.aroPrice, 10) || 0;
        const was = Math.max(p, parseInt(el.dataset.aroCmp, 10) || 0);
        const now = Math.round(p * (100 - pct) / 100);
        el.classList.add('aro-dp');
        el.innerHTML = el.hasAttribute('data-aro-short')
          ? fmt(now)
          : '<span class="aro-dp__pair"><s class="aro-dp__was">' + fmt(was) + '</s> <span class="aro-dp__now">' + fmt(now) + '</span></span>' +
            '<span class="aro-dp__tag" title="Descuento de tu paquete aplicado"><svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 12.6V4.5A1.5 1.5 0 0 1 4.5 3h8.1a1.5 1.5 0 0 1 1.06.44l7 7a1.5 1.5 0 0 1 0 2.12l-8.1 8.1a1.5 1.5 0 0 1-2.12 0l-7-7A1.5 1.5 0 0 1 3 12.6z"/><circle cx="8" cy="8" r="1.6" fill="#fff"/></svg>−' + pct + '%</span>';
      });
    }

    /* Celular: deslizar el carrito a la derecha lo cierra; deslizar un producto a la izquierda muestra el bote de basura */
    setupSwipe() {
      const OPEN = -80;
      let x0 = 0, y0 = 0, dx = 0, base = 0, active = false, mode = null, line = null, inner = null;
      this.panel.addEventListener('touchstart', (e) => {
        if (e.target.closest('.aro-ups__row, input')) { active = false; return; }
        const t = e.touches[0];
        x0 = t.clientX; y0 = t.clientY; dx = 0; active = true; mode = null;
        line = e.target.closest('.aro-line--swipe');
        inner = line && line.querySelector('.aro-line__in');
        if (this.swiped && this.swiped !== line) this.closeSwipe();
        base = line && line.classList.contains('is-open') ? OPEN : 0;
      }, { passive: true });
      this.panel.addEventListener('touchmove', (e) => {
        if (!active) return;
        const t = e.touches[0];
        const mx = t.clientX - x0, my = t.clientY - y0;
        if (mode === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) {
          if (Math.abs(mx) <= Math.abs(my)) mode = 'v';
          else if (inner && (mx < 0 || base < 0)) mode = 'line';
          else mode = mx > 0 ? 'panel' : 'v';
        }
        if (mode === 'line') {
          dx = Math.min(0, Math.max(OPEN - 24, base + mx));
          inner.style.transition = 'none';
          inner.style.transform = 'translateX(' + dx + 'px)';
        } else if (mode === 'panel') {
          dx = Math.max(0, mx);
          this.panel.style.transition = 'none';
          this.panel.style.transform = 'translateX(' + dx + 'px)';
        }
      }, { passive: true });
      this.panel.addEventListener('touchend', () => {
        if (!active) return;
        active = false;
        if (mode === 'line') {
          inner.style.transition = '';
          if (dx < OPEN / 2) this.openSwipe(line); else this.closeSwipe(line);
        } else if (mode === 'panel') {
          this.panel.style.transition = '';
          if (dx > 90) this.close(); else this.panel.style.transform = '';
        }
      }, { passive: true });
    }

    openSwipe(line) {
      if (this.swiped && this.swiped !== line) this.closeSwipe();
      line.classList.add('is-open');
      line.querySelector('.aro-line__in').style.transform = 'translateX(-80px)';
      this.swiped = line;
    }

    closeSwipe(line) {
      line = line || this.swiped;
      if (!line) return;
      line.classList.remove('is-open');
      const inner = line.querySelector('.aro-line__in');
      if (inner) inner.style.transform = '';
      if (this.swiped === line) this.swiped = null;
    }

    /* ---------- render ---------- */
    money(cents) {
      const v = (cents || 0) / 100;
      return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }

    render() {
      if (!this.cart) return;
      const st = this.state();
      const visible = st.items.filter((i) => !this.isProtection(i));
      const totalQty = visible.reduce((s, i) => s + i.quantity, 0);
      const countEl = this.$('[data-cart-count]');
      if (countEl) countEl.textContent = totalQty ? totalQty + (totalQty === 1 ? ' artículo' : ' artículos') : '';
      this.updateBubble(totalQty);
      const empty = visible.length === 0;
      this.$('[data-empty]').hidden = !empty;
      /* El pie con el total y el pago siempre se queda abajo, aunque esté vacío */
      const co = this.$('[data-checkout]');
      if (co) { co.classList.toggle('is-off', empty); co.setAttribute('aria-disabled', String(empty)); co.tabIndex = empty ? -1 : 0; }
      const protBox = this.$('[data-prot-box]');
      if (protBox) protBox.hidden = empty;
      this.renderJourney(st, empty);
      this.renderLines(st.items.filter((i) => !this.giftType(i) && !this.isProtection(i)));
      this.renderGifts(st);
      this.renderUpsell(st, empty);
      this.renderTotals(st);
      this.applyPrices();
    }

    updateBubble(n) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => { el.textContent = n; });
    }

    renderJourney(st, empty) {
      const el = this.$('[data-journey]');
      if (!el) return;
      el.hidden = !this.cfg.promo || empty;
      if (el.hidden) return;
      const n = st.count;
      const lvl = Math.min(n, 4);
      el.dataset.lvl = lvl;
      /* Hito de 1 perfume (sin texto) y luego 3 tramos iguales: 2, 3 y 4 perfumes */
      const POS = { 1: 16, 2: 44, 3: 72, 4: 100 };
      const fill = n ? POS[lvl] : 0;
      const stops = [
        { at: 2, pill: IC.truck(12) + 'GRATIS', truck: true, label: '2 perfumes', sub: IC.soap(11) + 'Jabón' },
        { at: 3, pill: '−10%', label: '3 perfumes', sub: IC.mini(11) + '1 de 30 ml' },
        { at: 4, pill: '−15%', label: '4 perfumes', sub: IC.mini(11) + '2 de 30 ml' },
      ];
      /* El mensaje crece con el paquete: con 4 o más se celebra */
      let ic = 'tag', msg;
      if (n >= 4) {
        const r = n % 4;
        ic = 'crown';
        msg = r === 0
          ? (n === 4 ? '<b>¡Sacaste el máximo!</b> 15% menos + 3 regalos + envío gratis' : '<b>¡Sacaste el máximo!</b> Mejor precio y todos tus regalos')
          : '<b>15% asegurado.</b> 1 más y sumas ' + (r === 1 ? 'otro jabón de regalo' : 'otro perfume de 30 ml');
      } else if (n === 3) { ic = 'spark'; msg = '<b>¡Ya casi!</b> 1 más y llegas al máximo: <b>15%</b> + 2 de 30 ml'; }
      else if (n === 2) { ic = 'gift'; msg = '<b>¡Jabón y envío gratis!</b> 1 más y ahorras <b>10%</b> + 1 de 30 ml'; }
      else if (n === 1) msg = 'Agrega 1 más y llévate <b>jabón + envío gratis</b>';
      else msg = 'Lleva 2 perfumes y te regalamos <b>jabón + envío gratis</b>';
      el.innerHTML =
        '<div class="aro-j__track"><span class="aro-j__fill" style="width:' + fill + '%"></span>' +
          '<span class="aro-j__dot' + (n >= 1 ? ' is-done' : '') + '" style="left:' + POS[1] + '%"></span>' +
          stops.map((s) => '<span class="aro-j__stop' + (n >= s.at ? ' is-done' : '') + (s.truck ? ' aro-j__stop--truck' : '') + '" style="left:' + POS[s.at] + '%"><b>' + s.pill + '</b></span>').join('') +
        '</div>' +
        '<div class="aro-j__labels"><span class="aro-j__one' + (n >= 1 ? ' is-done' : '') + '" style="left:' + POS[1] + '%">1 perfume</span>' + stops.map((s) => '<span class="' + (n >= s.at ? 'is-done' : '') + '" style="left:' + POS[s.at] + '%">' + esc(s.label) + '<small>' + s.sub + '</small></span>').join('') + '</div>' +
        '<p class="aro-j__msg">' + IC[ic](17) + '<span>' + msg + '</span></p>';
    }

    lineName(item) {
      const p = this.byHandle.get(this.baseHandle(item));
      if (p) return { n: p.n, i: p.i };
      const tt = String(item.product_title || '').replace(/^🎁\s*/, '').replace(/\s*\((100% off|GRATIS)\)\s*$/i, '');
      const m = tt.match(/nspirad[oa] en ([^)]+)\)/);
      return { n: tt.split(' (')[0].split(' - ')[0].trim(), i: m ? m[1].trim() : '' };
    }

    renderLines(lines) {
      const el = this.$('[data-lines]');
      el.innerHTML = lines.map((item) => {
        const nm = this.lineName(item);
        const img = sized(item.image, 240);
        const off = item.original_line_price - item.final_line_price;
        return '<div class="aro-line aro-line--swipe" data-key="' + esc(item.key) + '">' +
          '<button type="button" class="aro-line__del" data-del aria-label="Eliminar ' + esc(nm.n) + '" tabindex="-1">' + IC.trash(22) + '</button>' +
          '<div class="aro-line__in">' +
            '<a class="aro-line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="88" height="88">' : '') + '</a>' +
            '<div class="aro-line__info">' +
              '<a class="aro-line__name" href="' + esc(item.url) + '">' + esc(nm.n) + '</a>' +
              (nm.i ? '<p class="aro-line__sub">Inspirado en ' + esc(nm.i) + '</p>' : (item.variant_title && !/default/i.test(item.variant_title) ? '<p class="aro-line__sub">' + esc(item.variant_title) + '</p>' : '')) +
              (off > 0 ? '<p class="aro-line__off"><span class="aro-hl">Ahorras ' + this.money(off) + '</span></p>' : '') +
              '<div class="aro-line__row">' +
                '<p class="aro-line__price"><b>' + this.money(item.final_line_price) + '</b>' + (off > 0 ? ' <s>' + this.money(item.original_line_price) + '</s>' : '') + '</p>' +
                '<div class="aro-qty"><button type="button" data-qty="-1" aria-label="Quitar uno">−</button><span>' + item.quantity + '</span><button type="button" data-qty="1" aria-label="Agregar uno">+</button></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    soapLabel(item) {
      const s = this.cfg.soaps.find((x) => x.handle === this.baseHandle(item));
      return s ? s.label : '';
    }

    renderGifts(st) {
      const el = this.$('[data-gifts]');
      const lines = st.soaps.concat(st.minis);
      const need = st.needMinis + st.needSoaps;
      if (!lines.length && !need) { el.innerHTML = ''; return; }
      const cmp = this.cfg.giftCompare;
      let html = '';
      html += lines.map((item) => {
        const type = this.giftType(item);
        const nm = type === 'soap' ? { n: 'Jabón ' + this.soapLabel(item), i: '' } : this.lineName(item);
        const img = sized(item.image, 240);
        const base = this.byHandle.get(this.baseHandle(item));
        const href = base ? this.root + 'products/' + base.h : item.url;
        return '<div class="aro-line aro-line--gift aro-line--swipe" data-key="' + esc(item.key) + '" data-type="' + type + '">' +
          '<button type="button" class="aro-line__del" data-del aria-label="Quitar ' + esc(nm.n) + '" tabindex="-1">' + IC.trash(22) + '</button>' +
          '<div class="aro-line__in">' +
            '<a class="aro-line__img" href="' + esc(href) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="88" height="88">' : '') + '</a>' +
            '<div class="aro-line__info">' +
              '<a class="aro-line__name" href="' + esc(href) + '">' + esc(nm.n) + '</a>' +
              '<p class="aro-line__sub">' + (type === 'mini' ? 'Perfume de 30 ml' : 'Jabón artesanal') + (item.quantity > 1 ? ' · ' + item.quantity + ' piezas' : '') + '</p>' +
              '<p class="aro-line__off"><span class="aro-hl">Ahorras ' + this.money(cmp * item.quantity) + '</span></p>' +
              '<div class="aro-line__row">' +
                '<p class="aro-line__price"><b class="is-free">GRATIS</b> <s>' + this.money(cmp * item.quantity) + '</s></p>' +
                '<div class="aro-qty"><button type="button" data-qty="-1" aria-label="Quitar uno">−</button><span>' + item.quantity + '</span><button type="button" class="is-off" disabled aria-label="Los regalos dependen de tu paquete">+</button></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      if (need) {
        const parts = [];
        if (st.needSoaps) parts.push(st.needSoaps + ' jabón' + (st.needSoaps > 1 ? 'es' : ''));
        if (st.needMinis) parts.push(st.needMinis + ' perfume' + (st.needMinis > 1 ? 's' : '') + ' de 30 ml');
        html += '<button type="button" class="aro-gifts__pick" data-pick><span class="aro-gifts__pick-ic" aria-hidden="true">🎁</span>' +
          '<span><b>Te falta elegir ' + parts.join(' y ') + '</b><small>Toca para elegir tu regalo</small></span>' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
      }
      el.innerHTML = html;
    }

    renderUpsell(st, empty) {
      const el = this.$('[data-upsell]');
      const max = this.cfg.upsellCount || 0;
      if (empty || !max) { el.innerHTML = ''; return; }
      const inCart = new Set(st.items.map((i) => i.handle));
      /* Primero los perfumes elegidos en la app (en ese orden), luego el resto del catálogo */
      const pri = (this.cfg.upsellHandles || []).map((h) => this.byHandle.get(h)).filter(Boolean);
      const pool = pri.concat(this.cfg.perfumes.filter((p) => !pri.includes(p)));
      const picks = pool.filter((p) => p.a && !inCart.has(p.h)).slice(0, max);
      if (!picks.length) { el.innerHTML = ''; return; }
      /* El título y el precio dependen del paquete actual: muestra a cuánto queda el perfume que agregas */
      const now = rule(st.count);
      const next = rule(st.count + 1);
      let why = 'También te puede gustar';
      let pct = 0;
      if (this.cfg.promo && st.count) {
        pct = next.pct;
        if (next.pct && next.pct === now.pct) why = 'Añade más al ' + next.pct + '% off';
        else if (next.pct > now.pct) why = 'Agrega 1 y todo queda al ' + next.pct + '% off';
        else if (next.soaps > now.soaps) why = 'Agrega 1 y llévate jabón + envío gratis';
      } else if (this.cfg.promo) why = 'Arma tu paquete';
      const price = (p) => {
        if (pct) return '<b>' + this.money(Math.round(p.p * (100 - pct) / 100)) + '</b> <s>' + this.money(p.p) + '</s>';
        return '<b>' + this.money(p.p) + '</b>' + (p.c > p.p ? ' <s>' + this.money(p.c) + '</s>' : '');
      };
      el.innerHTML = '<p class="aro-sec__t">' + esc(why) + '</p><div class="aro-ups__row">' +
        picks.map((p) => '<button type="button" class="aro-ups__card" data-upsell-add="' + p.v + '" aria-label="Agregar ' + esc(p.n) + '">' +
          '<span class="aro-ups__img"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="64" height="64"></span>' +
          '<span class="aro-ups__info"><span class="aro-ups__name">' + esc(p.n) + '</span>' + (p.i ? '<span class="aro-ups__insp">' + esc(p.i) + '</span>' : '') + '<span class="aro-ups__price">' + price(p) + '</span></span>' +
          '<span class="aro-ups__add" aria-hidden="true">' + IC.plus(18) + '</span>' +
        '</button>').join('') + '</div>';
    }

    renderTotals(st) {
      const c = this.cart;
      const original = c.original_total_price != null ? c.original_total_price : c.items_subtotal_price;
      const total = c.total_price;
      const save = Math.max(0, original - total) + this.giftSavings(st);
      this.$('[data-save-row]').hidden = save <= 0;
      this.$('[data-save]').textContent = '−' + this.money(save);
      this.$('[data-total]').textContent = this.money(total);
      this.$('[data-ship]').textContent = total >= this.cfg.freeShipping ? 'Envío gratis · impuestos incluidos' : 'Envío gratis desde ' + this.money(this.cfg.freeShipping) + ' · impuestos incluidos';
      const on = st.items.some((i) => this.isProtection(i));
      const prot = this.$('[data-protection]');
      if (prot) prot.checked = on;
      const box = this.$('[data-prot-box]');
      if (box) box.classList.toggle('is-on', on);
      const state = this.$('[data-prot-state]');
      if (state) state.textContent = on ? 'Agregada ✓' : 'Agregar';
    }

    /* Las copias de BOGOS cuestan $0: su ahorro es el precio tachado */
    giftSavings(st) {
      return st.soaps.concat(st.minis).filter((i) => i.original_line_price === 0).reduce((s, i) => s + this.cfg.giftCompare * i.quantity, 0);
    }

    /* ---------- acciones ---------- */
    async onClick(e) {
      const line = e.target.closest('.aro-line');
      const qty = e.target.closest('[data-qty]');
      const ch = e.target.closest('[data-change]');
      const pick = e.target.closest('[data-pick]');
      const up = e.target.closest('[data-upsell-add]');
      const del = e.target.closest('[data-del]');
      /* Con el bote de basura visible, tocar el producto solo lo regresa */
      if (this.swiped && !del) {
        if (e.target.closest('.aro-line.is-open .aro-line__in')) e.preventDefault();
        this.closeSwipe();
        if (line && line.classList.contains('aro-line--swipe')) return;
      }
      try {
        if (del && line) {
          line.classList.add('is-removing');
          await this.change(line.dataset.key, 0);
        } else if (qty && line) {
          const item = this.cart.items.find((i) => i.key === line.dataset.key);
          await this.change(item.key, Math.max(0, item.quantity + Number(qty.dataset.qty)));
        } else if (ch && line) {
          this.openGift({ replaceKey: line.dataset.key, type: ch.dataset.change });
        } else if (pick) {
          this.snoozed = false;
          this.openGift();
        } else if (up) {
          up.disabled = true;
          up.classList.add('is-busy');
          await this.api('cart/add.js', { items: [{ id: Number(up.dataset.upsellAdd), quantity: 1 }] });
          await this.trackUpsell(up.dataset.upsellAdd);
          this.snoozed = false;
          await this.refresh();
        }
      } catch (err) { this.toast(err.message); }
    }

    /* Métricas de la app: guarda en el carrito qué variantes se agregaron desde la sugerencia */
    async trackUpsell(id) {
      try {
        const cart = await this.api('cart.js');
        const prev = String((cart.attributes || {})._aro_upsell || '').split(',').filter(Boolean);
        if (!prev.includes(String(id))) prev.push(String(id));
        await this.api('cart/update.js', { attributes: { _aro_upsell: prev.slice(-20).join(',') } });
      } catch (e) {}
    }

    /* Al bajar perfumes, los regalos que ya no se ganan se quitan en la misma operación */
    planChange(key, quantity) {
      const updates = { [key]: quantity };
      const items = ((this.cart && this.cart.items) || []).map((i) => (i.key === key ? Object.assign({}, i, { quantity }) : i)).filter((i) => i.quantity > 0);
      const count = items.filter((i) => this.isPerfume(i)).reduce((s, i) => s + i.quantity, 0);
      const earned = rule(count);
      const trim = (lines, allowed) => {
        let extra = lines.reduce((s, i) => s + i.quantity, 0) - allowed;
        for (let i = lines.length - 1; i >= 0 && extra > 0; i--) {
          const n = Math.min(lines[i].quantity, extra);
          updates[lines[i].key] = lines[i].quantity - n;
          extra -= n;
        }
      };
      trim(items.filter((i) => this.giftType(i) === 'mini'), earned.minis);
      trim(items.filter((i) => this.giftType(i) === 'soap'), earned.soaps);
      return updates;
    }

    async change(key, quantity) {
      this.panel.classList.add('is-loading');
      try {
        const updates = this.planChange(key, quantity);
        this.cart = Object.keys(updates).length > 1
          ? await this.api('cart/update.js', { updates })
          : await this.api('cart/change.js', { id: key, quantity });
        this.snoozed = false;
        await this.reconcile();
        this.render();
        this.maybeOpenGift();
      } finally { this.panel.classList.remove('is-loading'); }
    }

    async toggleProtection(on) {
      if (!this.cfg.protection) return;
      const line = this.cart.items.find((i) => this.isProtection(i));
      try {
        if (on && !line) { await this.api('cart/add.js', { items: [{ id: this.cfg.protection.id, quantity: 1 }] }); this.cart = await this.api('cart.js'); }
        if (!on && line) this.cart = await this.api('cart/change.js', { id: line.key, quantity: 0 });
        this.render();
      } catch (err) { this.toast(err.message); }
    }

    /* ---------- selector de regalos ---------- */
    async openGift(opts) {
      opts = opts || {};
      const st = this.state();
      let step = null;
      if (opts.replaceKey) step = opts.type;
      else if (st.needSoaps) step = 'soap';
      else if (st.needMinis) step = 'mini';
      if (!step) return;
      this.giftCtx = { step, replaceKey: opts.replaceKey || null };
      if (step === 'mini') await this.resolveClones();
      this.giftFamily = 'all';
      this.giftQuery = '';
      const search = this.$('[data-gift-search]');
      if (search) search.value = '';
      this.renderGift();
      if (!this.giftOpen) {
        this.gift.hidden = false;
        this.giftOpen = true;
        requestAnimationFrame(() => this.gift.classList.add('is-open'));
      }
    }

    closeGift(byUser) {
      if (this.celebrateEnd) this.celebrateEnd();
      if (byUser) this.snoozed = true; /* vuelve a aparecer en el siguiente cambio del carrito */
      this.gift.classList.remove('is-open');
      this.giftOpen = false;
      setTimeout(() => { if (!this.giftOpen) this.gift.hidden = true; }, 260);
    }

    giftItems() {
      const clones = this.cfg.giftSource === 'clones';
      return this.cfg.perfumes.map((p) => {
        /* Si el tema ve la variante de 30 ml y está agotada, no se ofrece (ni en modo copias) */
        if (p.m && !p.ma) return Object.assign({}, p, { gid: null });
        if ((this.cfg.giftExclude || []).some((h) => String(h).trim() === p.h)) return Object.assign({}, p, { gid: null });
        const id = clones ? (this.cloneMap[p.h] || null) : (p.ma ? p.m : null);
        return Object.assign({}, p, { gid: id });
      }).filter((p) => p.gid);
    }

    soapOptions() {
      const clones = this.cfg.giftSource === 'clones';
      return this.cfg.soaps.map((s) => Object.assign({}, s, { gid: clones ? s.clone : (s.available ? s.id : null) })).filter((s) => s.gid);
    }

    renderGift() {
      const c = this.giftCtx;
      const st = this.state();
      const isSoap = c.step === 'soap';
      const total = st.earned.soaps + st.earned.minis;
      const have = st.nSoaps + st.nMinis;
      this.showGiftView('pick');
      const stepEl = this.$('[data-gift-step]');
      stepEl.hidden = false;
      stepEl.style.visibility = (c.replaceKey || total < 2) ? 'hidden' : '';
      const nth = Math.min(have + 1, total);
      stepEl.textContent = nth + '/' + total;
      const eb = this.$('[data-gift-eyebrow]');
      eb.hidden = !!c.replaceKey;
      /* texto de arriba según el regalo que toca: único, primero, siguiente o último */
      const tx = this.cfg.text || {};
      eb.textContent = total < 2 ? (tx.eyebrow || eb.textContent)
        : nth === 1 ? (tx.eyebrowFirst || tx.eyebrow || eb.textContent)
        : nth >= total ? (tx.eyebrowLast || tx.eyebrow || eb.textContent)
        : (tx.eyebrowNext || tx.eyebrow || eb.textContent);
      this.$('[data-gift-title]').textContent = c.replaceKey ? 'Cambia tu regalo' : (isSoap ? this.cfg.text.giftTitleSoap : this.cfg.text.giftTitleMini);
      const sub = this.$('[data-gift-sub]');
      sub.hidden = !c.replaceKey;
      sub.textContent = c.replaceKey ? 'Toca el nuevo regalo' : '';
      const soapsEl = this.$('[data-gift-soaps]');
      const minisEl = this.$('[data-gift-minis]');
      soapsEl.hidden = !isSoap;
      minisEl.hidden = isSoap;
      this.$('[data-gift-hint]').hidden = true;
      if (isSoap) {
        soapsEl.innerHTML = this.soapOptions().map((s) =>
          '<button type="button" class="aro-pc aro-pc--soap" data-soap="' + esc(s.handle) + '">' +
            (s.img ? '<img src="' + esc(s.img.replace('width=240', 'width=700')) + '" alt="" loading="lazy">' : '') +
            '<span class="aro-pc__shade"></span>' +
            '<span class="aro-pc__txt"><b class="aro-pc__name">Jabón ' + esc(s.label) + '</b>' +
            '<span class="aro-pc__price"><s>' + this.money(this.cfg.giftCompare) + '</s> GRATIS</span></span>' +
          '</button>').join('');
        soapsEl.querySelectorAll('[data-soap]').forEach((b) => b.addEventListener('click', () => this.addGift('soap', b.dataset.soap, b)));
      } else {
        this.renderFams();
        this.renderRail();
      }
    }

    /* Familias: círculos con ícono que ocupan el ancho; al tocar uno se expande con su nombre */
    famList() {
      const map = new Map();
      this.giftItems().forEach((p) => { if (p.f && !map.has(p.f)) map.set(p.f, { k: p.f, name: p.fn || this.cfg.families[p.f] || p.f, color: p.fc || FAM_DEF[p.f] }); });
      const order = Object.keys(this.cfg.families);
      return [...map.values()].sort((a, b) => order.indexOf(a.k) - order.indexOf(b.k));
    }

    renderFams() {
      const el = this.$('[data-gift-chips]');
      const sel = this.giftFamily;
      el.classList.toggle('has-sel', sel !== 'all');
      el.innerHTML = this.famList().map((f) => {
        const on = sel === f.k;
        const style = '--fc:' + f.color + ';--fi:' + ink(f.color) + ';--ft:' + (lum(f.color) > .62 ? '#0b1a33' : '#fff');
        return '<button type="button" class="aro-fam' + (on ? ' is-on' : '') + '" data-fam="' + esc(f.k) + '" style="' + style + '" aria-pressed="' + on + '" aria-label="' + esc(f.name) + '">' +
          svg(16, FAM_IC[f.k] || '<circle cx="12" cy="12" r="7"/>') + '<span>' + esc(f.name) + '</span></button>';
      }).join('');
      /* Se cambian las clases en los mismos botones para que la transición círculo ↔ pill sea suave */
      el.querySelectorAll('[data-fam]').forEach((b) => b.addEventListener('click', () => {
        this.giftFamily = this.giftFamily === b.dataset.fam ? 'all' : b.dataset.fam;
        el.classList.toggle('has-sel', this.giftFamily !== 'all');
        el.querySelectorAll('[data-fam]').forEach((x) => {
          const on = x.dataset.fam === this.giftFamily;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', String(on));
        });
        this.renderRail();
      }));
    }

    /* Carrusel horizontal infinito: la lista se repite 3 veces y se recentra al llegar a una orilla */
    renderRail() {
      const q = this.giftQuery;
      const fams = new Map(this.famList().map((f) => [f.k, f]));
      const list = this.giftItems().filter((p) => (this.giftFamily === 'all' || p.f === this.giftFamily) && (!q || norm(p.n + ' ' + p.i).includes(q)));
      const free = this.$('[data-gift-allfree]');
      if (free) free.innerHTML = '<b>GRATIS</b><s>' + this.money(this.cfg.giftCompare) + '</s>';
      this.railLoop = list.length > 2;
      this.rail.classList.toggle('is-few', !this.railLoop);
      this.$('[data-railwrap]').classList.toggle('is-empty', !list.length);
      if (!list.length) { this.rail.innerHTML = '<p class="aro-gift__none">No encontramos ese perfume</p>'; return; }
      const card = (p) => {
        const f = fams.get(p.f);
        return '<button type="button" class="aro-pc aro-gift__pc" data-mini="' + esc(p.h) + '" aria-label="Elegir ' + esc(p.n) + '">' +
          '<img src="' + esc(String(p.img).replace(/width=\d+/, 'width=600')) + '" alt="" loading="lazy" draggable="false">' +
          '<span class="aro-pc__shade"></span>' +
          (f ? '<span class="aro-pc__fam" style="--fc:' + f.color + ';--ft:' + (lum(f.color) > .62 ? '#0b1a33' : '#fff') + '">' + esc(f.name) + '</span>' : '') +
          '<span class="aro-pc__txt"><b class="aro-pc__name">' + esc(p.n) + '</b>' + (p.i ? '<span class="aro-pc__sub">Inspirado en ' + esc(p.i) + '</span>' : '') + '</span>' +
        '</button>';
      };
      const one = list.map(card).join('');
      this.rail.innerHTML = this.railLoop ? one + one + one : one;
      this.rail.querySelectorAll('[data-mini]').forEach((b) => b.addEventListener('click', (e) => {
        if (Math.abs(e.clientX - (this.railX == null ? e.clientX : this.railX)) > 8) return;
        this.addGift('mini', b.dataset.mini, b);
      }));
      requestAnimationFrame(() => {
        this.rail.style.scrollBehavior = 'auto';
        this.rail.scrollLeft = this.railLoop ? this.rail.scrollWidth / 3 : 0;
        this.rail.style.scrollBehavior = '';
      });
    }

    loopRail() {
      if (!this.railLoop) return;
      const third = this.rail.scrollWidth / 3;
      const x = this.rail.scrollLeft;
      if (x < third * 0.25 || x > third * 1.75) {
        this.rail.style.scrollBehavior = 'auto';
        this.rail.scrollLeft = x < third * 0.25 ? x + third : x - third;
        this.rail.style.scrollBehavior = '';
      }
    }

    nudgeRail(dir) {
      const card = this.rail.querySelector('.aro-gift__pc');
      const step = card ? card.getBoundingClientRect().width + 12 : 200;
      this.rail.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    }

    /* Confeti y sonido al elegir un regalo */
    audio() {
      if (!this.cfg.sound) return null;
      try {
        if (!this.ac) { const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; this.ac = new AC(); }
        if (this.ac.state === 'suspended') this.ac.resume();
        return this.ac;
      } catch (e) { return null; }
    }

    chime(final) {
      const ac = this.audio();
      if (!ac) return;
      const notes = final ? [784, 988, 1175, 1568] : [988, 1319];
      const t0 = ac.currentTime + .02;
      notes.forEach((f, i) => {
        const o = ac.createOscillator();
        const g = ac.createGain();
        o.type = 'sine';
        o.frequency.value = f;
        const t = t0 + i * (final ? .09 : .1);
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(.16, t + .015);
        g.gain.exponentialRampToValueAtTime(.0008, t + .55);
        o.connect(g).connect(ac.destination);
        o.start(t);
        o.stop(t + .6);
      });
    }

    confetti(final) {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let cv = this.$('[data-confetti]');
      if (!cv) { cv = document.createElement('canvas'); cv.className = 'aro-confetti'; cv.setAttribute('data-confetti', ''); cv.setAttribute('aria-hidden', 'true'); this.appendChild(cv); }
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const W = window.innerWidth, H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      const ctx = cv.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const box = this.$('.aro-gift__box');
      const r = box ? box.getBoundingClientRect() : { left: W / 2, width: 0, top: H / 2, height: 0 };
      const cx = r.left + r.width / 2, cy = r.top + r.height * .38;
      const colors = ['#0b1a33', '#2456b8', '#4a86f5', '#a9bde6', '#ffd27a', '#f2b84b', '#ffffff'];
      const n = final ? 170 : 110;
      const parts = [];
      for (let i = 0; i < n; i++) {
        const a = Math.random() * Math.PI * 2;
        const v = (final ? 7 : 5.5) + Math.random() * 6;
        parts.push({ x: cx, y: cy, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 4, w: 5 + Math.random() * 6, h: 3 + Math.random() * 4, r: Math.random() * 6, vr: (Math.random() - .5) * .35, c: colors[i % colors.length], round: Math.random() < .3 });
      }
      const start = performance.now();
      const dur = final ? 2200 : 1700;
      cancelAnimationFrame(this.confT);
      const tick = (now) => {
        const k = (now - start) / dur;
        ctx.clearRect(0, 0, W, H);
        if (k >= 1) { ctx.clearRect(0, 0, W, H); return; }
        parts.forEach((p) => {
          p.vy += .22; p.vx *= .985; p.vy *= .985;
          p.x += p.vx; p.y += p.vy; p.r += p.vr;
          ctx.save();
          ctx.globalAlpha = Math.max(0, 1 - Math.max(0, k - .6) / .4);
          ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c;
          if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.h / 1.4, 0, Math.PI * 2); ctx.fill(); }
          else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 2)) + .6);
          ctx.restore();
        });
        this.confT = requestAnimationFrame(tick);
      };
      this.confT = requestAnimationFrame(tick);
    }

    /* Tocar = agregar. Después pasa al siguiente regalo pendiente o se cierra. */
    async addGift(type, handle, btn) {
      if (this.busy) return;
      const c = this.giftCtx;
      let id = null;
      if (type === 'soap') { const s = this.soapOptions().find((x) => x.handle === handle); id = s && s.gid; }
      else { const p = this.giftItems().find((x) => x.h === handle); id = p && p.gid; }
      if (!id) return;
      this.audio();
      this.busy = true;
      if (btn) btn.classList.add('is-picked');
      const pick = type === 'soap'
        ? { name: 'Jabón ' + ((this.soapOptions().find((x) => x.handle === handle) || {}).label || ''), img: (this.soapOptions().find((x) => x.handle === handle) || {}).img }
        : { name: (this.byHandle.get(handle) || {}).n, img: (this.byHandle.get(handle) || {}).img };
      try {
        if (c.replaceKey) {
          /* Si la línea tiene 2 piezas iguales, solo se cambia una */
          const old = this.cart.items.find((i) => i.key === c.replaceKey);
          await this.api('cart/change.js', { id: c.replaceKey, quantity: old ? Math.max(0, old.quantity - 1) : 0 });
        }
        await this.api('cart/add.js', { items: [{ id, quantity: 1, properties: { [GIFT_KEY]: type === 'soap' ? 'jabon' : 'mini' } }] });
        this.cart = await this.api('cart.js');
        this.busy = false;
        await this.reconcile();
        this.render();
        const st = this.state();
        const more = !c.replaceKey && (st.needSoaps || st.needMinis);
        this.busy = true;
        await this.celebrate(pick, more ? 'next' : (c.replaceKey ? 'swap' : 'final'), st);
        this.busy = false;
        if (more && this.giftOpen) await this.openGift();
      } catch (err) {
        this.toast(err.message);
        if (btn) btn.classList.remove('is-picked');
      } finally { this.busy = false; }
    }

    showGiftView(view) {
      this.$('[data-gift-pick]').hidden = view !== 'pick';
      this.$('[data-gift-done]').hidden = view !== 'done';
    }

    /* Animación: el regalo cae en una caja que se cierra. Después pasa al siguiente o confirma que ya están todos. */
    celebrate(pick, mode, st) {
      return new Promise((resolve) => {
        const done = this.$('[data-gift-done]');
        const total = st.earned.soaps + st.earned.minis;
        const have = st.nSoaps + st.nMinis;
        const img = pick.img ? String(pick.img).replace(/width=\d+/, 'width=200') : '';
        let title, sub, cta = '';
        const SECS = 3;
        if (mode === 'next') {
          title = '¡Añadiste tu regalo!';
          sub = esc(pick.name);
        } else if (mode === 'swap') {
          title = '¡Cambiamos tu regalo!';
          sub = esc(pick.name);
        } else {
          title = total > 1 ? '¡Ya tienes todos tus regalos!' : '¡Añadiste tu regalo!';
          sub = 'Ya están en tu carrito, sin costo';
          cta = '<button type="button" class="aro-gift__ok" data-gift-ok>Ver mi carrito <span data-gift-secs>(' + SECS + ')</span></button>';
        }
        /* El contador (2/3) queda en el mismo lugar que en el selector */
        done.innerHTML =
          '<p class="aro-gift__step"' + (total > 1 && mode !== 'swap' ? '' : ' style="visibility:hidden"') + '>' + Math.min(have, total) + '/' + total + '</p>' +
          '<div class="aro-gift__done-mid">' +
            '<div class="aro-gbox' + (mode === 'final' ? ' is-final' : '') + '" aria-hidden="true">' +
              (img ? '<img class="aro-gbox__item" src="' + esc(img) + '" alt="">' : '') +
              '<span class="aro-gbox__body"></span><span class="aro-gbox__lid"></span>' +
              '<i class="aro-gbox__sp s1"></i><i class="aro-gbox__sp s2"></i><i class="aro-gbox__sp s3"></i><i class="aro-gbox__sp s4"></i>' +
            '</div>' +
            '<h2 class="aro-gift__title">' + title + '</h2>' +
            '<p class="aro-gift__sub aro-gift__sub--done">' + sub + '</p>' +
          '</div>' + cta;
        this.showGiftView('done');
        if (this.cfg.confetti !== false) this.confetti(mode === 'final');
        this.chime(mode === 'final');
        this.celebrateEnd = () => { this.celebrateEnd = null; clearTimeout(this.celebrateT); clearInterval(this.countT); resolve(); };
        const finish = () => {
          if (mode !== 'next') this.closeGift(false);
          if (this.celebrateEnd) this.celebrateEnd();
        };
        const ok = done.querySelector('[data-gift-ok]');
        if (ok) ok.addEventListener('click', finish);
        if (mode === 'final') {
          /* Cuenta regresiva en el botón (3, 2, 1) y se cierra solo */
          let left = SECS;
          const secs = done.querySelector('[data-gift-secs]');
          clearInterval(this.countT);
          this.countT = setInterval(() => {
            left -= 1;
            if (secs) secs.textContent = left > 0 ? '(' + left + ')' : '';
            if (left <= 0) finish();
          }, 1000);
        } else {
          this.celebrateT = setTimeout(finish, mode === 'next' ? 1500 : 1600);
        }
      });
    }

    toast(msg) {
      const t = this.$('[data-toast]');
      if (!t) return;
      t.textContent = msg;
      t.hidden = false;
      t.classList.add('is-on');
      clearTimeout(this.toastT);
      this.toastT = setTimeout(() => { t.classList.remove('is-on'); setTimeout(() => { t.hidden = true; }, 300); }, 2600);
    }
  }

  customElements.define('aro-cart', AroCart);
})();
